import { BpAnswers } from '@boldpenguin/agent-quote-start';

import axios from '../../../../shared/axios';

import { AppDispatch } from '../../../../store';

import * as actionTypes from '../constants/actionTypes';

const getQuoteApplicationDataStart = () => {
  return {
    type: actionTypes.GET_QUOTE_APPLICATION_DATA_START,
  };
};

const getQuoteApplicationDataSuccess = (data: BpAnswers) => {
  return {
    type: actionTypes.GET_QUOTE_APPLICATION_DATA_SUCCESS,
    data,
  };
};

const getQuoteApplicationDataFail = (error: any) => {
  return {
    type: actionTypes.GET_QUOTE_APPLICATION_DATA_FAIL,
    error,
  };
};

export const getQuoteApplicationData = (quoteApplicationId: string) => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getQuoteApplicationDataStart());

      const url = `/bold-penguin-integration/get-quote-info/${quoteApplicationId}`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getQuoteApplicationDataSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getQuoteApplicationDataFail(err));
          reject(err);
        });
    });
  };
};

const saveBoldPenguinApplicationIdStart = () => {
  return {
    type: actionTypes.SAVE_BOLD_PENGUIN_APPLICATION_ID_START,
  };
};

const saveBoldPenguinApplicationIdSuccess = (data: any) => {
  return {
    type: actionTypes.SAVE_BOLD_PENGUIN_APPLICATION_ID_SUCCESS,
    data,
  };
};

const saveBoldPenguinApplicationIdFail = (error: any) => {
  return {
    type: actionTypes.SAVE_BOLD_PENGUIN_APPLICATION_ID_FAIL,
    error,
  };
};

export const saveBoldPenguinApplicationId = (quoteApplicationId: string, bpApplicationId: string) => {
  return (dispatch: AppDispatch) => {
    dispatch(saveBoldPenguinApplicationIdStart());

    const url = `/bold-penguin-integration/save-bold-penguin-application-id/${quoteApplicationId}/${bpApplicationId}`;

    axios
      .post(url)
      .then((response) => {
        dispatch(saveBoldPenguinApplicationIdSuccess(response.data));
      })
      .catch((err) => {
        dispatch(saveBoldPenguinApplicationIdFail(err));
      });
  };
};
